import firebase from 'firebase';
import $ from 'jquery';
import _ from 'lodash';

import View from '../view/view.js';
import completeGroupTpl from './complete-group.tpl.html';
import './complete-group.styles.less';

//import PlayersView from './players/players.view.js';

class CompleteGroupView extends View {

	constructor (data, options) {
		super(completeGroupTpl, data, options);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnSaveMatch: '.btn-save-match'
		});
	}

	render(data) {
		super.render(data);


	}

	initializeEvents() {
		//TODO: make individual views for each match
		this.ui.btnSaveMatch.click((evt) => this.saveMatch(evt));
	}

	saveMatch(evt) {
		let 
		$match = $(evt.currentTarget).closest('.match'),
		$player1Input = $match.find('input[name="player1"]'),
		$player2Input = $match.find('input[name="player2"]');

		firebase.database().ref('/matches/' + $match.attr('id') + '/player1').update({
			games: _.clamp(parseInt($player1Input.val()) || 0, -1, 3)
		});
		firebase.database().ref('/matches/' + $match.attr('id') + '/player2').update({
			games: _.clamp(parseInt($player2Input.val()) || 0, -1, 3)
		});
	}

	/*onShow() {

	}*/


}

export default CompleteGroupView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_components/complete-group/complete-group.view.js